import SectionHeader from "@/components/site/SectionHeader";
import Seo from "@/components/seo/Seo";
import { breadcrumbSchema } from "@/components/seo/schema";

const SECTIONS = [
  {
    h: "1. Free Website Build",
    p: [
      "Equinox Systems offers a Free Custom Website Program in which the website development is provided at no upfront cost to the Client. There is no upfront website development fee. The Client pays only for hosting, maintenance, support, and updates as described in these Terms.",
    ],
  },
  {
    h: "2. Monthly Service Fee",
    p: [
      "The Free Custom Website Program requires a monthly service fee of $200 per month covering hosting, maintenance, technical support, and minor content updates. The first monthly payment is due before development begins. Payments are processed securely via Stripe.",
    ],
  },
  {
    h: "3. Six-Month Minimum Commitment",
    p: [
      "The Free Custom Website Program requires a minimum commitment of six (6) months at $200 per month. Development will not begin until the agreement is signed and the first monthly payment is received.",
    ],
  },
  {
    h: "4. Website Ownership Transfer",
    p: [
      "Equinox Systems retains ownership of the website and its source code during the initial six-month agreement. Upon successful completion of the agreement and receipt of all required payments, ownership of the website transfers to the Client at no additional cost.",
    ],
  },
  {
    h: "5. Domain Name Ownership",
    p: [
      "The Client purchases and owns their domain name. Equinox Systems assists with DNS configuration, deployment, technical setup, and integrations, but the domain remains the property of the Client at all times.",
    ],
  },
  {
    h: "6. Included Maintenance Services",
    p: [
      "The monthly service fee includes secure hosting, ongoing maintenance, performance optimization, security monitoring, technical support, and minor content updates. Major redesigns, new feature development, and advanced SEO services are scoped and billed separately.",
    ],
  },
  {
    h: "7. Client Responsibilities",
    p: [
      "The Client agrees to provide timely content, feedback, approvals, branding assets, and any access required to complete the website. The Client is responsible for the accuracy and legality of all content provided and for purchasing and maintaining their own domain name.",
    ],
  },
  {
    h: "8. Early Cancellation",
    p: [
      "If the Client cancels before completion of the initial six-month term, the remaining contract balance immediately becomes due. Ownership transfer does not occur until all obligations under the agreement are satisfied.",
    ],
  },
  {
    h: "9. Payment Failure",
    p: [
      "If a monthly payment fails or is not received, Equinox Systems may suspend hosting, maintenance, and support services until payment is resolved. Continued non-payment may result in cancellation of services, and any remaining balance under the six-month minimum commitment becomes immediately due.",
    ],
  },
  {
    h: "10. Post-Term Service",
    p: [
      "After ownership transfers, Clients may continue month-to-month hosting, maintenance, support, and updates for $200 per month with no long-term commitment. Clients may also elect to move their website to another hosting provider after ownership transfers.",
    ],
  },
  {
    h: "11. SEO Disclaimer",
    p: [
      "A foundational SEO setup is included with every website. Equinox Systems does not guarantee specific search engine rankings, traffic volumes, lead counts, or revenue. Search engine results depend on factors outside our control, including search engine algorithms, competition, and market conditions. Advanced SEO services are available separately.",
    ],
  },
  {
    h: "12. Limitation of Liability",
    p: [
      "To the maximum extent permitted by law, Equinox Systems' total liability for any claim arising out of or relating to the services is limited to the fees paid by the Client for the specific service in dispute. Equinox Systems is not liable for indirect, incidental, consequential, or punitive damages, including lost profits or business interruption.",
    ],
  },
  {
    h: "13. Governing Law",
    p: [
      "These Terms are governed by and construed in accordance with the laws of the state in which the Client's business is located, without regard to its conflict of law provisions. Any disputes shall be resolved in the courts located in that state.",
    ],
  },
];

export default function Terms() {
  return (
    <div data-testid="page-terms">
      <Seo
        title="Terms & Conditions | Equinox Systems"
        description="Terms & Conditions for Equinox Systems, including the Free Custom Website Program: monthly service fee, six-month commitment, ownership transfer, domain ownership, cancellation, and more."
        path="/terms"
        schemas={[breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Terms & Conditions", path: "/terms" }])]}
      />
      <section className="relative py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <SectionHeader as="h1" eyebrow="Legal" title="Terms & Conditions" />
          <div className="rounded-2xl border border-blue-500/30 bg-blue-500/[0.06] p-5 mb-8 text-sm text-gray-200 leading-relaxed">
            By applying for or using the Equinox Systems Free Custom Website Program or any Equinox
            Systems service, you agree to these Terms &amp; Conditions. Please read them carefully.
          </div>
          <div className="space-y-8 text-sm">
            {SECTIONS.map((s) => (
              <div key={s.h} data-testid={`terms-section-${s.h.split(".")[0]}`}>
                <h2 className="font-display text-xl text-white mb-2">{s.h}</h2>
                {s.p.map((para, i) => (
                  <p key={i} className="text-gray-300 leading-relaxed">{para}</p>
                ))}
              </div>
            ))}
            <div>
              <h2 className="font-display text-xl text-white mb-2">Contact</h2>
              <p className="text-gray-300 leading-relaxed">
                Questions about these Terms? Email{" "}
                <a className="text-blue-400 hover:text-blue-300" href="mailto:Equinox@freedomcoreventures.com">
                  Equinox@freedomcoreventures.com
                </a>.
              </p>
            </div>
            <p className="text-xs text-gray-500 pt-4 border-t border-white/10">
              These Terms are provided for general informational purposes and do not constitute legal
              advice. Last updated: June 2026.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
